import { apiFetch } from "./client";

export async function login(username, password) {
  const response = await apiFetch("/api/token/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    throw new Error("Login failed");
  }
  else {
    console.log("Ingelogd!")
  }

  return response.json(); // { access, refresh }
}

export async function requestTwoFactorCode(username, password) {
  const response = await apiFetch("/api/2fa/request/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    throw new Error("2FA request failed");
  }

  return response.json(); // { two_factor_token, expires_in }
}

export async function verifyTwoFactorCode(token, code) {
  const response = await apiFetch("/api/2fa/verify/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, code }),
  });

  if (!response.ok) {
    throw new Error("2FA verify failed");
  }

  return response.json(); // { access, refresh }
}

export async function resendTwoFactorCode(token) {
  const response = await apiFetch("/api/2fa/resend/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    throw new Error("2FA resend failed");
  }

  return response.json(); // { two_factor_token, expires_in }
}
